<template>
  <div class="mt-2">
    <div>
      <v-card>
        <v-card-text style="min-height: 350px; position: relative">
          <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
          <template v-if="reportuserbytimeOptions && !loading">
            <apexchart
              ref="reportuserbytime"
              type="area"
              height="350"
              :options="reportuserbytimeOptions"
              :series="reportuserbytimeSeries"
            ></apexchart>
          </template>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import DashboardGraphLoading from './DashboardGraphLoading'
import api from '@/api'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import VueApexCharts from 'vue-apexcharts'
import utc from 'dayjs/plugin/utc'
import advancedFormat from 'dayjs/plugin/advancedFormat'
dayjs.extend(utc)
dayjs.extend(advancedFormat)
export default {
  props: ['type', 'app', 'date', 'fbpost'],
  data() {
    return {
      loading: true,

      reportuserbytimeSeries: null,
      reportuserbytimeOptions: {
        chart: {
          height: 350,
          type: 'area'
        },
        stroke: {
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: this.$t('Information received over time')
          },
          tickAmount: 1
        },
        tooltip: {
          x: {
            format: 'HH:mm'
          }
        }
      }
    }
  },
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  async mounted() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      var response = await this.fetchData()

      await this.$nextTick()
      var data = []
      var raw = response.data[0]
      let today = dayjs()

      for (let index = 0; index <= 23; index++) {
        const element = raw[`time_${index}`]
        let date = today.format(`YYYY-MM-DDT${index.toString()}:00`)
        const tzOffset = new Date().getTimezoneOffset()

        data.push([
          dayjs(date)
            .utcOffset(0, true)
            .valueOf(),
          parseInt(element)
        ])
      }

      this.reportuserbytimeSeries = [
        { name: this.$t('Information received over time'), data: data }
      ]
      var max = 0
      if (data && data.length > 0) {
        max = data.reduce((acc, val) => {
          acc = acc === undefined || val[1] > acc ? val[1] : acc
          return acc
        }, [])
      }

      if (this.$refs.reportuserbytime) {
        this.$refs.reportuserbytime.updateOptions({
          yaxis: {
            max: max + 5
          }
        })
      }
      this.$emit('onLoaded', { loading: false, data: this.reportuserbytimeSeries })
      this.loading = false
    },
    fetchData() {
      return new Promise((resolve, reject) => {
        var data = {
          body: {
            pageid: this.selectedBot.pageid,
            app: this.app,
            from_date: dayjs(this.date.start).format('YYYY-MM-DD'),
            to_date: dayjs(this.date.end).format('YYYY-MM-DD')
          }
        }
        if (this.type == 'inbox') {
          api.post_report_inbox_user_by_time(data, (error, response) => {
            if (error) {
              reject(error)
            }

            if (response.responsecode == 200) {
              this.$emit('input', response.data)
              resolve(response)
            } else {
              reject(response.responsecode + ': Something went wrong')
            }
          })
        } else {
          if (this.fbpost) {
            data.body.question_source = this.fbpost.id
          }
          api.post_report_comment_user_by_time(data, (error, response) => {
            if (error) {
              reject(error)
            }

            if (response.responsecode == 200) {
              this.$emit('input', response.data)
              resolve(response)
            } else {
              reject(response.responsecode + ': Something went wrong')
            }
          })
        }
      })
    }
  },
  watch: {
    async app(newVal, oldVal) {
      if (newVal != oldVal) {
        await this.loadData()
      }
    },
    async date(newVal, oldVal) {
      if (newVal != oldVal) {
        await this.loadData()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/ReportUserByTime.vue